import { SelectComponent as l } from "../SelectComponent/SelectComponent.js";
import '../assets/OrderBy.css';const n = "op_label_wFXQ5", o = {
  label: n
};
function b(e) {
  let {
    orderByLabelAttributes: t = {},
    orderByInputAttributes: r = {}
  } = e;
  return e.orderByInputAttributes.options == null ? null : /* @__PURE__ */ React.createElement("label", { className: o.label, ...t }, "Order by", /* @__PURE__ */ React.createElement(
    l,
    {
      name: "order_by",
      ...r
    }
  ));
}
export {
  b as OrderBy
};
